// Hosting may serve generated page directories with or without a trailing slash.
export const normalizePathname = (pathname) => pathname.replace(/\/+$/, '') || '/';
